import deepmerge from 'deepmerge';
import { useSelector } from 'react-redux';
import { EN_GB } from '@clearscore-group/lib.config.i18n';
import { selectors } from '@clearscore-group/lib.redux.market';
var isObject = function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object;
};
var ignoreArrays = function ignoreArrays(_, source) {
  return source;
};
var useLanguage = function useLanguage(language, forceLocale) {
  if (!language || !isObject(language)) throw new Error('A language object must be provided');
  var activeLocale = useSelector(selectors.getActiveLocale);
  var locale = forceLocale || activeLocale;
  if (language[locale]) {
    return language[EN_GB] ? deepmerge(language[EN_GB], language[locale], {
      arrayMerge: ignoreArrays
    }) : language[locale];
  }
  return language[EN_GB] || null;
};
export default useLanguage;